export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const data = reader.result

      if (typeof data === 'string') {
        const base64Data = data.split(',')[1]
        resolve(base64Data)
        return
      }

      resolve('')
    }

    reader.onerror = (error) => {
      reject(error)
    }

    reader.readAsDataURL(file)
  })
}
